import { useQuery } from '@tanstack/react-query'
import requestGetEmployeeOrders from 'businessTraveller/api/requestGetEmployeeOrders'
import { useAppSelector } from 'hooks/reduxHooks'

interface Params {
  timeframe: 'upcoming' | 'past' | 'cancelled' | 'qualificationWindow';
  page: number;
  limit: number;
  // Filter orders by if the requester is a booking manager, traveller or both
  filterBy?: 'bookingManager' | 'traveller' | 'all'
  refetchInterval?: number | false;
}

function useEmployeeOrders(params: Params) {
  const { timeframe, page, limit, filterBy, refetchInterval } = params

  const businessId = useAppSelector(state => state.businessTraveller.currentBusinessAccount?.business?.id)

  const query = useQuery({
    queryKey: ['orders', 'employee', businessId, timeframe, page, limit, filterBy],
    queryFn: async() => requestGetEmployeeOrders({ businessId: businessId!, timeframe, page, limit, filterBy }),
    enabled: !!businessId,
    staleTime: 0,
    refetchInterval,
  })

  return {
    ...query,
    orders: query.data?.orders || [],
    total: query.data?.meta?.total || 0,
    currentPage: page,
    totalPages: query.data?.meta?.total ? Math.ceil(query.data.meta.total / limit) : 0,
  }
}

export default useEmployeeOrders
